let audioCtx;

export function playTaskCompletionSound(type = 'main') {
  try {
    const enabled = localStorage.getItem('completionSoundEnabled');
    if (enabled !== null && enabled !== 'true') {
      return;
    }

    const Ctx = window.AudioContext || window.webkitAudioContext;
    audioCtx = audioCtx || new Ctx();
    // Ensure context is running and avoid initial loudness
    if (audioCtx.state === 'suspended') {
      audioCtx.resume();
    }

    const isMain = type === 'main';
    const duration = isMain ? 0.8 : 0.25;
    const now = audioCtx.currentTime;

    const gain = audioCtx.createGain();
    gain.gain.setValueAtTime(0, now);
    const peak = isMain ? 0.2 : 0.15;
    gain.gain.linearRampToValueAtTime(peak, now + 0.01);
    gain.gain.exponentialRampToValueAtTime(0.0001, now + duration);
    gain.connect(audioCtx.destination);

    if (isMain) {
      // Soft major dyad for a pleasant chime
      const osc1 = audioCtx.createOscillator();
      const osc2 = audioCtx.createOscillator();

      osc1.type = 'sine';
      osc2.type = 'sine';

      osc1.frequency.setValueAtTime(523.25, now); // C5
      osc2.frequency.setValueAtTime(659.25, now); // E5

      osc1.connect(gain);
      osc2.connect(gain);

      osc1.start(now);
      osc2.start(now);
      osc1.stop(now + duration);
      osc2.stop(now + duration);
    } else {
      // Upward plop for optimistic feedback
      const osc = audioCtx.createOscillator();
      osc.type = 'sine';
      osc.frequency.setValueAtTime(440, now);
      osc.frequency.linearRampToValueAtTime(660, now + duration);

      osc.connect(gain);

      osc.start(now);
      osc.stop(now + duration);
    }
  } catch {
    // Audio context not supported or user gesture required
  }
}